export const formatRelevance = (relevance: number | string) => {
  const relevanceNum = typeof relevance === 'number' ? relevance : parseFloat(relevance);
  return `${Math.round(relevanceNum <= 1 ? relevanceNum * 100 : relevanceNum)}%`;
};
